import { createFileRoute } from '@tanstack/react-router';
import { RelatorioCompraComprasPorFornecedor } from '@/features/relatorio/page/compra/compras-por-fornecedor/RelatorioCompraComprasPorFornecedor';

export const Route = createFileRoute('/a/relatorio/compra/compras-por-fornecedor')({
    component: RelatorioCompraComprasPorFornecedor,
});
